import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../UI';
import { Menu, X, LogOut, LayoutDashboard, Calendar, DollarSign } from 'lucide-react';

const AuthenticatedNav = ({ user }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const navLinks = [
    { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { to: '/leaves', label: 'Leaves', icon: Calendar },
    { to: '/payroll', label: 'Payroll', icon: DollarSign },
  ];

  return (
    <div className="relative">
      {/* Desktop Navigation */}
      <div className="hidden md:flex items-center space-x-4">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center">
            <span className="text-white text-sm font-semibold">
              {user.name.charAt(0).toUpperCase()}
            </span>
          </div>
          <div>
            <p className="text-sm font-medium text-secondary-900">{user.name}</p>
            <p className="text-xs text-secondary-500 capitalize">{user.role}</p>
          </div>
        </div>
        {navLinks.map((link) => (
          <Link key={link.to} to={link.to}>
            <Button variant="outline" size="sm">{link.label}</Button>
          </Link>
        ))}
        <Button variant="outline" size="sm" onClick={handleLogout}>
          <LogOut className="w-4 h-4 mr-1" />
          Logout
        </Button>
      </div>

      {/* Mobile Navigation */}
      <div className="flex md:hidden items-center space-x-2">
        {navLinks.map((link) => (
          <Link key={link.to} to={link.to}>
            <Button variant="outline" size="sm" className="px-2 py-1 text-xs">
              {link.label}
            </Button>
          </Link>
        ))}
        <Button variant="outline" size="sm" onClick={handleLogout} className="px-2 py-1 text-xs">
          <LogOut className="w-3 h-3 mr-1" />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default AuthenticatedNav;
